export * from "./contracts.ts";
export * from "./bundle.ts";
export * from "./admission.ts";
export * from "./admission-v2.ts";
export * from "./fill.ts";
export * from "./graph-parity.ts";
export * from "./variable-binding-graph.ts";
export * from "./source-rights-declaration.ts";
export * from "./f6-visual-conformance.ts";
export * from "./f6-threshold-fit.ts";
export * from "./component-ontology-candidate.ts";
export {
  buildDesignTokenOntologyCandidate,
  deriveSelectedDesignTokenCollectionOpaqueIdsV2,
  verifyDesignTokenOntologyCandidate,
} from "./design-token-ontology-candidate-v2.ts";
export type {
  CanonicalDesignTokenRole,
  DeriveSelectedDesignTokenCollectionOpaqueIdsV2Input,
  DesignTokenOntologyCandidateInputV2,
  DesignTokenOntologyCandidateV2,
  DesignTokenType,
} from "./design-token-ontology-candidate-v2.ts";
export {
  getPreflightOpenPencilOntologyFactsV2,
  openVerifiedOpenPencilComponentReadbackV2,
  openVerifiedOpenPencilDesignTokenReadbackV2,
  preflightOpenPencilComponentBoundaryV2,
  preflightOpenPencilDesignTokenBoundaryV2,
} from "./ontology-candidate-boundary-v2.ts";
export type {
  OpenPencilOntologyAuthorityArtifactsV2,
  OpenPencilOntologyBoundaryInputV2,
  OpenPencilOntologySourceRefsV2,
  PreflightOpenPencilOntologyBoundaryV2,
  VerifiedOpenPencilOntologyBoundaryV2,
} from "./ontology-candidate-boundary-v2.ts";
export {
  ambiguousComponentRoleAliases,
  componentRoleAliases,
  createComponentRoleRegistry,
  mapComponentRole,
} from "./component-role-registry.ts";
export type {
  CanonicalComponentRole,
  ComponentRoleRegistry,
  ComponentRoleResolution,
} from "./component-role-registry.ts";
export {
  buildOpenPencilComponentOntologyCandidateV2,
  deriveSelectedComponentSetOpaqueIdsV2,
  verifyOpenPencilComponentOntologyCandidateV2,
} from "./component-ontology-candidate-v2.ts";
export type {
  DeriveSelectedComponentSetOpaqueIdsV2Input,
  OpenPencilComponentOntologyCandidateInputV2,
  OpenPencilComponentOntologyCandidateV2,
} from "./component-ontology-candidate-v2.ts";
export {
  deriveFixedWave1OpaqueCandidateSelectionV2,
  evaluateFoundationComponentWave1AuthorizedSelectionV2,
} from "./fixed-wave1-candidate-selection-v2.ts";
export type {
  FixedWave1OpaqueCandidateSelectionV2,
  FoundationComponentWave1AuthorizedSelectionEvaluationV2,
} from "./fixed-wave1-candidate-selection-v2.ts";
export {
  FOUNDATION_COMPONENT_WAVE1_COVERAGE_PROFILE,
  buildOntologyCoverageMatrixV2,
  createCoverageReadbackMemoizer,
  verifyOntologyCoverageMatrixV2,
} from "./coverage-matrix-v2.ts";
export type {
  BuildOntologyCoverageMatrixV2Input,
  CoverageReadbackMemoizer,
  CoverageReadbackMemoizerBrand,
  FigmaCommunityOntologyCoverageMatrixV2,
  FoundationCoverageRole,
  VerifiedComponentCoverageInputV2,
  VerifiedTokenCoverageInputV2,
} from "./coverage-matrix-v2.ts";
export {
  buildOpenPencilStructuralFactShards,
  validateOpenPencilFactShardManifestV2,
  validateOpenPencilStructuralFactShardV1,
  verifyOpenPencilStructuralProjection,
} from "./fact-shards.ts";
export type {
  OpaqueId,
  OpaqueObservation,
  OpenPencilFactShardKind,
  OpenPencilFactShardManifestV2,
  OpenPencilStructuralFactShardBuild,
  OpenPencilStructuralFactShardV1,
  SemanticCode,
  Sha256,
  StructuralFact,
  StructuralFactType,
  StructuralFlag,
  StructuralMetric,
  StructuralProjectionContext,
  StructuralRelation,
} from "./fact-shards.ts";
